export default "__VITE_ASSET__DLg2NxMF__"